/**
 * Payment / mandate iframes live under Prime dialogs or the Stripe element wrapper.
 * Do not treat those as removable "floating" overlays.
 */
export const isStripeIframeInProtectedContainer = (iframe: HTMLIFrameElement): boolean => {
  let parent: HTMLElement | null = iframe.parentElement;
  while (parent) {
    if (
      parent.classList.contains('p-dialog') ||
      parent.classList.contains('p-dialog-mask') ||
      parent.classList.contains('stripe-payment-element-wrapper') ||
      parent.querySelector('.stripe-payment-element-wrapper') ||
      parent.closest('.p-dialog') ||
      parent.closest('.p-dialog-mask')
    ) {
      return true;
    }
    parent = parent.parentElement;
  }
  return false;
};
